<div *ngIf="permission?.canSeePfIrcp">
  <div class="header_search">
    <div class="title-page">
      <h3>IRCP</h3>
    </div>
    <div class="content_search">
      <div class="new-project" *ngIf="permission?.canSave">
        <a class="btn btn-primary" type="btn" routerLink="adicionar">Novo</a>
      </div>
    </div>
  </div>

  <div class="system-table table-container">
    <div class="system-table-conteiner">
      <table>
        <thead>
          <tr>
            <th>Objetivo do Projeto</th>
            <th>Status atual</th>
            <th>Valor de repasse</th>
            <th>Valor de contrapartida</th>
            <th class="text-center btn-icon-td">Ações</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let item of ircpList">
            <tr>
              <td class="title"><span class="title-span">{{item?.ds_objective_project}}</span></td>
              <td>{{item?.str_status_value}}</td>
              <td>{{item?.transfer_value}}</td>
              <td>{{item?.counterpart_value}}</td>
              <td>
                <div class="btn-icon" *ngIf="item?.canSave">
                  <a class="icon-table" [routerLink]="item?.id">
                    <img src="assets/images/svgs/editar1.svg" alt="Editar" tooltip="Editar" placement="bottom">
                  </a>
                </div>
              </td>
            </tr>
          </ng-container>
          <tr *ngIf="!ircpList?.length" class="border-b-radius">
            <td colspan="5" class="text-center">Nenhum IRCP Cadastrado.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<app-loading [loader]="isLoading"></app-loading>